import _extend from 'lodash/extend';
import _isNil from 'lodash/isNil';

import config from 'src/config';
import authHelper from 'src/api/auth/helper';

function stripSlash(path) {
  if (path.startsWith('/')) return path.substring(1, path.length);

  return path;
}

function combinePaths(...args) {
  let fullPath = '';

  for (let i = 0; i < args.length; i++) { //eslint-disable-line
    const arg = args[i];

    if (i > 0) fullPath += '/';

    fullPath += stripSlash(arg);
  }

  return fullPath;
}

function apiUrl(path, params = {}) {
  const fullUrl = combinePaths(`${config.SDK_API_URL}`, path);

  return addQueryStringParams(fullUrl, _extend({
    auth: authHelper.getAuthToken()
  }, params));
}

function addQueryStringParams(url = '', params = {}) {
  Object.keys(params).forEach(key => {
    const value = params[key];

    if (!_isNil(value)) {
      if (url.indexOf('?') > 0) {
        url += `&${key}=${value}`;
      } else {
        url += `?${key}=${value}`;
      }
    }
  });

  return url;
}

export default {
  combinePaths,
  apiUrl,
  addQueryStringParams
};



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js